import { render, staticRenderFns } from "./PublicFrontPage.vue?vue&type=template&id=1521b6a0&"
import script from "./PublicFrontPage.vue?vue&type=script&lang=js&"
export * from "./PublicFrontPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports